import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { map } from "rxjs/operators";

import { AWSHttpClient } from "@intocare/aws";
import { Home } from "@intocare/interfaces";

import * as data from "../actions/homes.data";
import * as ui from "../actions/homes.ui";
import * as reducers from "../reducers";

@Injectable()
export class HomesModel {
	private http = inject(AWSHttpClient);
	private store = inject<Store<reducers.State>>(Store);

	homes$ = this.store.select(reducers.getHomes);
	loading$ = this.store.select(reducers.getHomesLoading);

	loadHomes() {
		this.store.dispatch(new ui.Loading());
		this.http.get<{ homes: Home[] }>("homes").subscribe((result: { homes: Home[] }) => {
			this.store.dispatch(new data.SetHomes(result.homes));
		});
	}

	getHome(id: string) {
		return this.homes$.pipe(
			map((homes) => {
				return homes.find((home) => home.id === id);
			}),
		);
	}
}
